const logsTab =  {
    LOAD_LOGS_TAB: "LOAD_LOGS_TAB",
    LOADED_LOGS_TAB: "LOADED_LOGS_TAB",
    ERROR_LOADING_LOGS_TAB: "ERROR_LOADING_LOGS_TAB",
    LOAD_LOG: "LOAD_LOG",
    LOADED_LOG: "LOADED_LOG",
    ERROR_LOADING_LOG: "ERROR_LOADING_LOG"
};

export default logsTab;